<template>
  <div v-if="modelsStore.models.length > 0" class="mb-16">
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-2xl font-semibold">Featured Models</h2>
      <NuxtLink 
        to="/models" 
        class="text-primary hover:underline"
      >
        View All Models
      </NuxtLink>
    </div>
    
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div 
        v-for="model in featuredModels" 
        :key="model.id"
        class="group flex flex-col rounded-lg overflow-hidden border border-border hover:border-primary transition-colors"
      >
        <div class="relative aspect-16/9 bg-accent/20 overflow-hidden">
          <img 
            :src="model.model_image" 
            :alt="model.title.rendered"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
          <div class="absolute inset-0 bg-linear-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div class="absolute bottom-0 left-0 right-0 p-3 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <NuxtLink 
              :to="`/models/${model.slug}`"
              class="text-sm font-medium text-white hover:underline"
            >
              View Details
            </NuxtLink>
          </div>
        </div>
        <div class="p-4">
          <h3 class="text-lg font-semibold mb-1">{{ model.title.rendered }}</h3>
          <p v-if="model.caption" class="text-sm text-muted-foreground line-clamp-2 mb-3">
            {{ model.caption }}
          </p>
          <div class="flex items-center justify-between mt-auto">
            <span v-if="model.segment" class="text-xs px-2 py-1 bg-secondary text-secondary-foreground rounded">
              {{ Array.isArray(model.segment) ? model.segment.join(', ') : model.segment }}
            </span>
            <NuxtLink 
              :to="`/models/${model.slug}`"
              class="text-sm font-medium text-primary hover:underline"
            >
              View Details
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useModelsStore } from '~/stores/models'
import { computed } from 'vue'

const modelsStore = useModelsStore()

// Get featured models (limit to 3)
const featuredModels = computed(() => {
  return modelsStore.models.slice(0, 3)
})
</script> 